var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFtterung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M32.341,5.406c0.298-1.19,1.131-2.23,2.356-2.725c1.225-0.495,2.547-0.326,3.588,0.324 c-0.298,1.19-1.131,2.23-2.356,2.725C34.704,6.225,33.382,6.056,32.341,5.406"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M28.893,7.595c0.899-0.836,2.164-1.254,3.461-1.002c1.297,0.252,2.313,1.114,2.833,2.225 c-0.898,0.836-2.163,1.255-3.461,1.002C30.429,9.568,29.413,8.707,28.893,7.595"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M23.875,9.623c0.898-0.836,2.163-1.254,3.46-1.002s2.313,1.113,2.833,2.225 c-0.898,0.835-2.163,1.253-3.46,1.001S24.395,10.734,23.875,9.623"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M18.856,11.65c0.899-0.836,2.164-1.254,3.461-1.002c1.297,0.252,2.312,1.114,2.833,2.226 c-0.899,0.836-2.164,1.254-3.461,1.002C20.393,13.624,19.376,12.762,18.856,11.65"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M13.838,13.678c0.898-0.836,2.163-1.254,3.46-1.002c1.297,0.252,2.313,1.114,2.833,2.226 c-0.898,0.836-2.163,1.254-3.46,1.002S14.358,14.79,13.838,13.678"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M8.819,15.706c0.899-0.836,2.164-1.255,3.461-1.002c1.297,0.252,2.313,1.113,2.833,2.225 c-0.899,0.836-2.164,1.254-3.461,1.002C10.356,17.679,9.339,16.817,8.819,15.706"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M28.351,6.252c1.227-0.023,2.428-0.601,3.186-1.683c0.757-1.082,0.89-2.408,0.492-3.569 c-1.228,0.023-2.429,0.601-3.186,1.683C28.085,3.765,27.952,5.091,28.351,6.252"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M23.332,8.279c1.227-0.022,2.427-0.601,3.185-1.683c0.759-1.082,0.892-2.408,0.492-3.568 c-1.227,0.022-2.427,0.6-3.185,1.683C23.066,5.793,22.934,7.118,23.332,8.279"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M18.314,10.307c1.227-0.023,2.427-0.601,3.185-1.683s0.89-2.408,0.492-3.569 c-1.227,0.023-2.428,0.601-3.185,1.683C18.048,7.82,17.915,9.146,18.314,10.307"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M13.295,12.334c1.227-0.022,2.428-0.6,3.185-1.683c0.758-1.082,0.891-2.407,0.492-3.568 c-1.227,0.022-2.427,0.601-3.185,1.683C13.029,9.848,12.897,11.174,13.295,12.334"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M8.277,14.362c1.227-0.023,2.427-0.602,3.185-1.684c0.758-1.082,0.89-2.408,0.492-3.569 c-1.227,0.023-2.428,0.601-3.185,1.683C8.011,11.875,7.878,13.201,8.277,14.362"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.075,
    x1: 7.541,
    y1: 15.441,
    x2: 0.995,
    y2: 18.085
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtterung);
export default __webpack_public_path__ + "static/media/fütterung.f365f1e9287edbcd3ce3505e574c7c67.svg";
export { ForwardRef as ReactComponent };